import React, { PureComponent } from "react";
import { changeLocation, goBack } from "api/Location";

class TeamReportsTopNavigation extends PureComponent {
  get steps() {
    const { current_year } = this.props;

    return [
      {
        section: 1,
        step: 1,
        title: "Intro Page"
      },
      {
        section: 1,
        step: 2,
        title: "Table of Contents"
      },
      {
        section: 2,
        step: 1,
        title: "Grade & Ranks"
      },
      {
        section: 2,
        step: 2,
        title: "KPI Analysis"
      },
      {
        section: 2,
        step: 3,
        title: current_year <= 4 ? "Market Share" : "Share Price"
      },
      {
        section: 2,
        step: 4,
        title: current_year <= 4 ? "Revenues" : "Earnings Per Share"
      },
      {
        section: 2,
        step: 5,
        title:
          current_year <= 4 ? "Gross Margins" : "Return on Invested Capital"
      },
      {
        section: 2,
        step: 6,
        title:
          current_year <= 4 ? "Share Price" : "Return on Net Operating Assets"
      },
      {
        section: 3,
        step: 1,
        title: "Financial Planning & Analysis"
      },
      {
        section: 3,
        step: 2,
        title: "Financial Planning & Analysis 2"
      },
      {
        section: 3,
        step: 3,
        title: "Financial Planning & Analysis 3"
      },
      {
        section: 3,
        step: 4,
        title: "Income Statement"
      },
      {
        section: 4,
        step: 1,
        title: "Market Analysis"
      },
      {
        section: 4,
        step: 2,
        title: "Market Analysis 2"
      },
      {
        section: 4,
        step: 3,
        title: "Market Analysis 3"
      },
      {
        section: 4,
        step: 4,
        title: "Market Analysis 4"
      },
      {
        section: 4,
        step: 5,
        title: "Market Analysis 5"
      },
      {
        section: 5,
        step: 1,
        title: "Operational Analysis"
      },
      {
        section: 5,
        step: 2,
        title: "Operational Analysis 2"
      },
      {
        section: 5,
        step: 3,
        title: "Operational Analysis 3"
      },
      {
        section: 5,
        step: 4,
        title: "Operational Analysis 4"
      },
      {
        section: 6,
        step: 1,
        title: "Financing Analysis"
      },
      {
        section: 6,
        step: 2,
        title: "Financing Analysis 2"
      },
      {
        section: 6,
        step: 3,
        title: "Financing Analysis 3"
      },
      {
        section: 6,
        step: 4,
        title: "Financing Analysis 4"
      },
      {
        section: 7,
        step: 1,
        title: "Financial Results"
      },
      {
        section: 7,
        step: 2,
        title: "Income Statement"
      },
      {
        section: 7,
        step: 3,
        title: "Balance Sheet"
      },
      {
        section: 7,
        step: 4,
        title: "Cash Flows"
      },
      {
        section: 7,
        step: 5,
        title: "End of Report"
      }
    ];
  }

  goHome = e => {
    e.preventDefault();

    const url = sessionStorage.getItem("previousLocation");
    if (url && url !== "") {
      changeLocation(url);
    } else {
      goBack();
    }
  };

  get currentStepIndex() {
    const { section, step } = this.props;
    const steps = this.steps;
    const index = steps.findIndex(
      i => i.section === section && i.step === step
    );

    return index;
  }

  get prevStep() {
    const index = this.currentStepIndex;
    const steps = this.steps;

    if (index === 0) {
      return null;
    }

    return steps[index - 1];
  }

  get nextStep() {
    const index = this.currentStepIndex;
    const steps = this.steps;

    if (index === steps.length - 1) {
      return null;
    }

    return steps[index + 1];
  }

  goToPrev = e => {
    e.preventDefault();

    const prevStep = this.prevStep;

    if (prevStep) {
      this.props.changeStep(prevStep.section, prevStep.step);
    }
  };

  goToNext = e => {
    e.preventDefault();

    const nextStep = this.nextStep;

    if (nextStep) {
      this.props.changeStep(nextStep.section, nextStep.step);
    }
  };

  render() {
    const prevStep = this.prevStep;
    const nextStep = this.nextStep;

    return (
      <div className="team-reports-top">
        <a href="/#" className="home-link" onClick={this.goHome}>
          <i className="fa fa-home" />
        </a>
        {prevStep && (
          <div className="team-reports-top-left-button">
            <div className="team-reports-top-button">
              <a href="/#" onClick={this.goToPrev}>
                <i className="fa fa-long-arrow-left" />
              </a>
              <span className="title">{prevStep.title}</span>
            </div>
          </div>
        )}
        {nextStep && (
          <div className="team-reports-top-right-button">
            <div className="team-reports-top-button right">
              <a href="/#" onClick={this.goToNext}>
                <i className="fa fa-long-arrow-right" />
              </a>
              <span className="title">{nextStep.title}</span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default TeamReportsTopNavigation;



// WEBPACK FOOTER //
// ./src/components/team-reports/navigation/top.js